import { z } from "zod";

const nonEmpty = z.string().min(1);

export const tenantBrandingDtoSchema = z.object({
  slug: nonEmpty,
  displayName: nonEmpty,
  logoUrl: nonEmpty.optional(),
  primaryColor: nonEmpty.optional(),
});

export const tenantBrandingResponseDtoSchema = z.object({
  data: tenantBrandingDtoSchema,
});

export type TenantBrandingDto = z.infer<typeof tenantBrandingDtoSchema>;

export const tenantIdentityDtoSchema = z.object({
  slug: nonEmpty,
  nameEn: nonEmpty,
  nameAr: nonEmpty,
});

export const tenantResolveResponseDtoSchema = z.object({
  data: tenantIdentityDtoSchema,
});

export type TenantIdentityDto = z.infer<typeof tenantIdentityDtoSchema>;
